import { render, staticRenderFns } from "./nuclideSetting.vue?vue&type=template&id=4dc9f6a5"
import script from "./nuclideSetting.vue?vue&type=script&lang=js"
export * from "./nuclideSetting.vue?vue&type=script&lang=js"
import style0 from "./nuclideSetting.vue?vue&type=style&index=0&id=4dc9f6a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports